import namespace from "@rdfjs/namespace";
const builder = namespace("http://w3id.org/nfdi4ing/metadata4ing#");
export const strict = builder;
export const loose = builder;
